<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Form-->
<div class="MainGrid">
	<label>Code:</label>
	<input class="form-control" type="text" [(ngModel)]="Code" placeholder="Code or abbreviation" />

	<label>Description:</label>
	<input class="form-control" type="text" [(ngModel)]="Desc" placeholder="Name or description" />

	<label>All Schools:</label>
	<input disabled style="width: 30px; margin-right: auto" class="form-control" type="checkbox" [(ngModel)]="AllSchools" />
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
